import {css} from 'quickstart/styled-components/system'

export const centerContent = css`
  display: flex;
  align-items: center;
  justify-content: center;
`
